import { getWithAuth } from 'services/http.service';
import { GET_CUSTOMER_DB_CREDENTIALS_BY_USER_ID } from 'services/url.service';

export const getCustomerDBCredentialsByUserId = () =>
  getWithAuth(GET_CUSTOMER_DB_CREDENTIALS_BY_USER_ID);
